module.exports = __webpack_public_path__ + "69898d49b431b6cbb96b7fdbb617eda5.svg";


//////////////////
// WEBPACK FOOTER
// ./client/components/canvas/icon-scissors.svg
// module id = 249
// module chunks = 0